import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://wip.fibrebondindustries.com/backend";

// ─── PHOTO THUMBNAIL ───────────────────────────────────────────────────────────
export const PhotoCell = ({ src, label, onView }) => {
  if (!src) return (
    <span style={{ color: "#9ca3af", fontSize: 12, fontStyle: "italic" }}>— No photo</span>
  );
  return (
    <button onClick={() => onView(BASE_URL + src)} style={{
      border: "none", background: "none", cursor: "pointer", padding: 0
    }}>
      <img
        src={BASE_URL + src}
        alt={label}
        style={{
          width: 56, height: 56, objectFit: "cover",
          borderRadius: 8,
          border: "2px solid #e5e7eb",
          transition: "all 0.2s ease-in-out",
          display: "block",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = "scale(1.15)";
          e.currentTarget.style.boxShadow = "0 8px 16px rgba(0,0,0,0.1)";
          e.currentTarget.style.borderColor = "#2563eb";
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.05)";
          e.currentTarget.style.borderColor = "#e5e7eb";
        }}
      />
    </button>
  );
};

// ─── LIGHTBOX ─────────────────────────────────────────────────────────────────
export const Lightbox = ({ src, onClose }) => {
  useEffect(() => {
    const handler = e => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [onClose]);
  
  if (!src) return null;
  
  const lightboxContent = (
    <div onClick={onClose} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.85)",
      zIndex: 999999, display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div onClick={e => e.stopPropagation()} style={{ position: "relative", maxWidth: "90vw", maxHeight: "90vh" }}>
        <img src={src} alt="Preview" style={{
          maxWidth: "90vw", maxHeight: "85vh",
          borderRadius: 12, boxShadow: "0 25px 60px rgba(0,0,0,.6)",
          display: "block"
        }} />
        <button onClick={onClose} style={{
          position: "absolute", top: -16, right: -16,
          background: "#ef4444", color: "#fff", border: "none",
          borderRadius: "50%", width: 32, height: 32,
          fontSize: 16, cursor: "pointer", lineHeight: "32px",
          fontWeight: 700, boxShadow: "0 4px 12px rgba(0,0,0,.3)",
          display: "flex", alignItems: "center", justifyContent: "center"
        }}>✕</button>
        <a href={src} download target="_blank" rel="noreferrer" style={{
          position: "absolute", bottom: -50, left: "50%", transform: "translateX(-50%)",
          background: "#2563eb", color: "#fff", borderRadius: 24,
          padding: "8px 24px", fontSize: 14, fontWeight: 600,
          textDecoration: "none", display: "inline-block",
          boxShadow: "0 4px 12px rgba(0,0,0,.3)",
          transition: "background 0.2s"
        }}
        onMouseEnter={e => e.currentTarget.style.background = "#1d4ed8"}
        onMouseLeave={e => e.currentTarget.style.background = "#2563eb"}
        >⬇ Download Image</a>
      </div>
    </div>
  );
  
  return createPortal(lightboxContent, document.body);
};
